// extracted by mini-css-extract-plugin
export default {"cardView":"Dashboard_cardView__D69Ns"};